import styled from "styled-components";

export const Container = styled.div`
	background: ${({ theme }) => theme.white};
	border-radius: 4px;
	padding: 1rem;
	width: 100%;
	max-width: 500px;
	font-weight: bold;
	text-align: left;
`;

export const AreaFooteButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

export const Link = styled.a`
	&&& {
		color: ${({ theme }) => theme.pantone2727C};
		text-decoration: underline;
		margin-left: 0.5rem;
		cursor: pointer;
		transition: filter 0.2s;

		&:hover {
			filter: brightness(1.2);
		}
	}
`;
